import { render, staticRenderFns } from "./About.vue?vue&type=template&id=841f9f38&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=841f9f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841f9f38",
  null
  
)

export default component.exports